module.exports = __webpack_public_path__ + "img/04d.3c8f082a.png";